import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "currency",
  "use": "currency-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"currency\"><path fill-rule=\"evenodd\" d=\"M23 4v12H5V4h18Zm-6 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM7 8v4a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2V8a2 2 0 0 1-2-2H9a2 2 0 0 1-2 2ZM1 8h2v10h16v2H1V8Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol